import { Component, OnInit, Optional } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService, GeneralService } from '@clooper/core';
import { IUser, CorporateAccountService } from '@clooper/core';
import { faAt, faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef ,ModalOptions} from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-invite-employee',
  templateUrl: './invite-employee.component.html',
  styleUrls: ['./invite-employee.component.scss']
})
export class InviteEmployeeComponent  implements OnInit {
  icons = {
    cancel: faTimes,
    close: faTimes,
    at: faAt
  };
  employees: any[] = [];
  roles = ['member', 'admin']
  form: FormGroup;
  inviteForm: FormGroup;
  loading = false;
  step1 = true;
  backendError = '';
  public onClose: Subject<boolean>;
  user: IUser;

  constructor(
    public business: CorporateAccountService,
    public bsModalRef: BsModalRef,
    @Optional() private auth: AuthService,
    private gs: GeneralService,
    private toastr: ToastrService
  ) {
    this.createForm()
    this.inviteForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      role: new FormControl('', [Validators.required])
    });
  }
  ngOnInit(): void {
    this.user = this.auth.getAuthorizedUser()

    this.onClose = new Subject();

  }

  createForm() {
    this.form = new FormGroup({
      email_addresses: new FormControl('', [Validators.required]),
      message: new FormControl('')
    });
    // this.getFormValueChange();
  }

  addEmployee() {
    this.backendError = '';
    if (this.inviteForm.valid) {
      let existingEmp = this.employees.filter((item) => item.email === this.inviteForm.value.email)
      if (existingEmp?.length > 0) return this.inviteForm.reset()
      this.employees.push({
        email: this.inviteForm.value.email,
        role: this.inviteForm.value.role,
        message: this.form.value.message
      })
      this.form.patchValue({
        email_addresses: this.employees
      })
      this.inviteForm.get('email')?.reset()
      this.inviteForm.get('role')?.setValue('')
      this.inviteForm.updateValueAndValidity()
    }


  }

  removeEmployee(i: number) {
    this.employees.splice(i, 1)
    if (this.employees.length === 0) {
      this.form.patchValue({
        email_addresses: null
      })
    }
  }


  addAddedEmployee() {
    this.backendError = '';
    this.loading = true;

    const data = this.employees.map((x: any) => {
      return {
        email: x.email,
        role: x.role,
        message: this.form.value.message
      }
    })
    this.business.inviteEmployee(this.user.business?._id, data).subscribe(
      (res: any) => {
        this.loading = false;
        if (res) {
          this.step1 = false;
        }
      },
      (err) => {
        this.loading = false;
        this.backendError = this.gs.getErrMsg(err);
        this.toastr.error(this.backendError);
      }
    );
  }

  close() {
    this.onClose.next(true);
    this.bsModalRef?.hide()
  }

}
